import React, { lazy } from 'react';
import EditorLoadableWrapper from '../../EditorLoadableWrapper';
import { EditorProps } from '../../types';
import retry from '../../../utils/chunkRetry';

const LoadableEditor = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "editor_v3", webpackPrefetch: true */
        './OriginalsQuestion'
      )
  )
);

const OriginalsQuestionLoadable: React.FC<
  Omit<EditorProps, 'extensionConfig' | 'presetId' | 'onFocus' | 'onBlur'>
> = props => {
  return (
    <EditorLoadableWrapper>
      <LoadableEditor {...props} />
    </EditorLoadableWrapper>
  );
};
OriginalsQuestionLoadable.displayName = 'OriginalsQuestion';

export default OriginalsQuestionLoadable;

